<template>
    <confirm-dialog title="면접거부 상세" maxWidth="400" hideActions>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <div class="mb-4 mb-lg-8">거부사유: {{ value.refuseMsg }}</div>
        <span class="page-text--sm grey-9--text"> 거부일시: {{ value.refusedAt.toDateTime() }} </span>
    </confirm-dialog>
</template>

<script>
import ConfirmDialog from "@/components/dumb/confirm-dialog.vue";
import { initExpoMatching } from "@/assets/variables";
export default {
    components: {
        ConfirmDialog,
    },
    props: {
        value: { type: Object, default: initExpoMatching },
    },
};
</script>

<style>
</style>